<template>
    <div id="download-card-window">

        <div class="download-card-window--inner">
            <div class="close-too-large-modal" @click="closeModal">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </div>
            <div>
                <h3>¡Carta Lista!</h3>
                <div id="imageOutput"></div>
                <a class="button1" :href="imageDataUrl" :download="cardColors.playerName.replace(/ /g, '_')">descargar</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['cardColors', 'imageDataUrl','readyForDownload'],
    methods: {
        closeModal() {
            this.$emit('close-modal');
        }
    }
}
</script>

<style lang="less">
 #download-card-window {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    background: var(--overlay_bg);
    text-align: center;
    padding: 1.5rem;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(10px); /* Adjust the blur radius as needed */
        z-index: -1;
    }

    .download-card-window--inner {
        position: relative;
        background: white;
        text-align: center;
        padding: 3rem 2rem 2rem;
        border-radius: var(--radius_global);
        z-index: 1;
        width: 100%;
        max-width: 400px;

        // a.downloadbtn-img {
        //     background: --base_orange;
        //     background: var(--button_gradient_orange);
        //     padding: 2rem;
        //     cursor: pointer;
        //     text-align: center;
        //     border-radius: var(--radius_global);
        //     font-family: var(--comic-font);
        //     text-transform: uppercase;
        //     text-shadow: 0 1px 3px black;
        //     border: 0;
        //     border-bottom: 2px solid #ee4e01;
        //     font-size: 1rem;
        //     color: #fff;
        //     margin: 2rem 0 0;
        // }
    }

 }

.close-too-large-modal {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    svg {
        width: 2rem;
        height: auto;
    }
}

 a.button1 {
    display: inline-block;
    margin-top: 2rem;
    background: var(--blue_main);
    color: var(--button1_color);
    border: var(--button1_border);
    padding: var(--button_paddingy) var(--button_paddingx);
    border-radius: var(--radius_global);
    cursor: pointer;
    font-family: var(--base-font);
    border: 0;
    font-size: 0.8rem;
    position: relative;
    overflow: hidden;
    text-transform: var(--button_transform);
    font-weight: 700;

    &:hover {
        background: var(--button1_hoverbg);
        color: var(--blue_main);
    }   
}

 #download-card-window h3 {
    font-size: 1.25rem;
    font-weight: 700;
 }

//  #download-card-window a {
//     background-color: #006aff;
//     text-decoration: none;
//     color: #fff;
//     padding: 1rem;
//     border-radius: 4px;
//     display: inline-block;
//     font-weight: 700;
//     margin: 1rem auto;
//     text-transform: capitalize;
//  }
</style>